import React, { useState } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import ServiceAuth from "src/services/auth/authToken";
import ServicePatient from "src/services/patient/patient";
import { getExpiresToken, parseJwt } from "src/shared/global/helpers";
import ManageStorage from "src/shared/global/manageStorage";
import { historyRouteState } from "src/store/global/historyState";
import { snackbarState } from "src/store/global/snackbarState";
import { userState } from "src/store/user/userState";
import { LoginSchema } from "../schemas/LoginSchema";
import {
  errorsReservationUserState,
  valuesFormReservationUserState,
} from "../state/atoms";
import { FamilyService } from "src/FamilyGroup/services/family";

const useAuthPatient = () => {
  const [valuesFormReservationUser, setValuesFormReservationUser] =
    useRecoilState(valuesFormReservationUserState);
  const [errorsReservationUser, setErrorsReservationUser] = useRecoilState(
    errorsReservationUserState
  );
  const setUser = useSetRecoilState(userState);
  const setSnackbar = useSetRecoilState(snackbarState);
  const [loading, setLoading] = useState(false);
  const historyRoute = useRecoilValue(historyRouteState);
  const handleChange = (ev) => {
    let { name, value } = ev.target;
    if (errorsReservationUser.hasOwnProperty(name)) {
      setErrorsReservationUser({ ...errorsReservationUser, [name]: [] });
    }

    if (value === undefined) value = "";

    setValuesFormReservationUser({
      ...valuesFormReservationUser,
      [name]: value,
    });
  };

  const handleLoginUser = async () => {
    setLoading(true);
    try {
      const loginSchema = new LoginSchema();
      const bodyValidate = await loginSchema.isValidSchema({
        ...valuesFormReservationUser,
      });

      if (bodyValidate.ok === false) {
        setErrorsReservationUser((currentState) => ({
          ...currentState,
          ...bodyValidate.dataErrors,
        }));

        return Promise.reject(bodyValidate);
      }

      const { data } = await ServiceAuth.loginUser(valuesFormReservationUser);

      ManageStorage.setItemStorage("tokenUser", data.accessToken);
      const detailUser = await getDetailPatient();

      const payload = {
        ...detailUser,
      };

      setUser((currentState) => ({
        ...currentState,
        isAuthenticated: true,
        payload: {
          ...payload,
        },
      }));

      autoLogoutWhenExpiredToken();

      return payload;
    } catch (error) {
      return Promise.reject(error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogoutUser = () => {
    const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
    if (tokenUser) {
      ManageStorage.removeItemFromStorage("tokenUser");
      setUser((currentState) => ({
        ...currentState,
        isAuthenticated: false,
        payload: null,
      }));

      const activeAccount = window.sessionStorage.getItem("activeAccount");
      if (activeAccount) {
        window.sessionStorage.removeItem("activeAccount");
      }

      setSnackbar({
        openAlert: true,
        severity: "info",
        text: "Su sesión ha finalizado",
        position: {
          vertical: "bottom",
          horizontal: "right",
        },
      });

      //historyRoute?.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/login`)
    }
  };

  const autoLogoutWhenExpiredToken = () => {
    const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
    if (tokenUser) {
      const payloadToken = parseJwt(tokenUser);
      const timeExpired = getExpiresToken(payloadToken.exp);

      setTimeout(() => {
        handleLogoutUser();
      }, timeExpired - 300000);
    }
  };

  const getDetailPatient = async () => {
    const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
    const activeAccount = window.sessionStorage.getItem("activeAccount");

    try {
      if (tokenUser) {
        const payloadToken = parseJwt(tokenUser);
        let userRut = payloadToken.Username;

        const familyGroup = await FamilyService.getFamilyGroup(
          payloadToken.Username
        );

        const familyAccount = familyGroup.data.find(
          (item) => {
            const rutPaciente = item.paciente?.pacRut || "";
            const rutUsuario = item.usuario?.uswRut || "";

            const rut = rutPaciente || rutUsuario;

            return rut === activeAccount && item.tutCuentaVerificada === 1;
          }
        );
        console.log(familyGroup.data, 'familyGroup');
        
        console.log(familyAccount, 'familyAccount');

        if (!familyAccount) {
          window.sessionStorage.removeItem("activeAccount");
        }

        if (activeAccount && activeAccount !== userRut && familyAccount) {
          userRut = activeAccount;
        }

        let userData = {};
        if (familyAccount && familyAccount.paciente) {
          const data = familyAccount.paciente;
          console.log(data, 'data family');

          userData = {
            "uswRut": data.pacRut,
            "uswNombres": data.pacNombres,
            "uswApePat": data.pacPaterno,
            "uswApeMat": data.pacMaterno,
            "uswFonoMovil": familyAccount.tutFonoMovil !== "" ? familyAccount.tutFonoMovil : null,
            "uswEmail": familyAccount.tutEmail !== "" ? familyAccount.tutEmail : null,
            "uswTieneCuenta": false,
          }

        } else {
          const response = await ServicePatient.getDetail(userRut);
          userData = response.data.data;

          userData = {
            ...userData,
            uswFonoMovil:
              userData.uswFonoMovil !== "" ? userData.uswFonoMovil : null,
            uswFonoFijo1:
              userData.uswFonoFijo1 === null || userData.uswFonoFijo1 === ""
                ? null
                : userData.uswFonoFijo1,
            uswCodFonoFijo1:
              userData.uswCodFonoFijo1 === null || userData.uswCodFonoFijo1 === ""
                ? null
                : userData.uswCodFonoFijo1,
            usuFonoCompleto:
              userData.uswFonoFijo1 !== "" ? userData.uswFonoFijo1 : null,
            isaCodigo: userData.isaCodigo !== "" ? userData.isaCodigo : null,
            uswTieneCuenta: true,
          };
        }

        console.log(userData, 'family');

        setUser((currentState) => ({
          ...currentState,
          payload: {
            ...userData,
          },
        }));
        return userData;
      }

      return null;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return {
    handleChange,
    handleLoginUser,
    handleLogoutUser,
    getDetailPatient,
    autoLogoutWhenExpiredToken,
    loading,
  };
};

export default useAuthPatient;
